"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradingRuleType = void 0;
// eslint-disable-next-line no-shadow
var GradingRuleType;
(function (GradingRuleType) {
    GradingRuleType["SCORELT"] = "scoreLt";
    GradingRuleType["SCOREGTE"] = "scoreGte";
    GradingRuleType["SCOREBETWEEN"] = "scoreBetween";
})(GradingRuleType = exports.GradingRuleType || (exports.GradingRuleType = {}));
exports.default = GradingRuleType;
